import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styles/updateBlog.css";
import LayOut from "../../components/LayOut";
import toast from "react-hot-toast";

const UpdateBlog = () => {
  const [blog, setBlog] = useState({
    name: "",
    description: "",
    author: "",
    slug: "",
    photo: null,
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams(); // Blog ID from URL
  const navigate = useNavigate();

  // Fetch blog data by ID to populate the form
  useEffect(() => {
    const fetchBlog = async () => {
      console.log(id);
      if (!id) {
        setError("Invalid blog ID");
        toast.error("Invalid Blog ID");
        return;
      }
      try {
        console.log("Fetching blog with ID:", id);
        const response = await axios.get(
          `https://portfoliomern-mxue.onrender.com/api/v1/blog/blog/${id}`
        );
        console.log("API Response:", response.data);
        if (response.data.success) {
          const blogData = response.data.blog;
          if (
            blogData.photo &&
            blogData.photo.data &&
            blogData.photo.contentType
          ) {
            const imageUrl = `data:${
              blogData.photo.contentType
            };base64,${Buffer.from(blogData.photo.data.data).toString(
              "base64"
            )}`;
            blogData.photo = imageUrl; // Convert photo to Base64
          }
          setBlog(blogData);
        } else {
          setError("Blog not found");
        }
      } catch (error) {
        console.error(
          "Error fetching blog:",
          error.response?.data || error.message
        );
        setError("Error fetching blog details.");
        toast.error("Error fetching blog details.");
      }
    };

    fetchBlog();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBlog({ ...blog, [name]: value });
  };

  const handleFileChange = (e) => {
    setBlog({ ...blog, photo: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!id) {
      setError("Invalid blog ID");
      toast.error("Invalid Blog ID");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("name", blog.name);
    formData.append("description", blog.description);
    formData.append("author", blog.author);
    formData.append("slug", blog.slug);
    if (blog.photo instanceof File) formData.append("photo", blog.photo);

    try {
      const response = await axios.put(
        `/api/v1/blog/update-blog/${id}`,
        formData
      );
      if (response.data.success) {
        navigate(`/blog/${id}`); // Redirect to the blog details page
        toast.success("Blog updated successfully");
      } else {
        setError("Error updating blog.");
        toast.error("Error updating blog.");
      }
    } catch (error) {
      console.error("Error updating blog:", error.message);
      setError("Error updating blog.");
      toast.error("Error updating blog.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LayOut>
      <div className="container mt-5" style={{ backgroundColor: "#101010" }}>
        <h2 className="text-center text-white">Update Blog</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="form-group mb-3">
            <input
              type="text"
              className="form-control"
              name="name"
              value={blog.name}
              onChange={handleChange}
              placeholder="Blog Name"
            />
          </div>
          <div className="form-group mb-3">
            <textarea
              className="form-control"
              name="description"
              rows="5"
              value={blog.description}
              onChange={handleChange}
              placeholder="Blog Description"
            />
          </div>
          <div className="form-group mb-3">
            <input
              type="text"
              className="form-control"
              name="author"
              value={blog.author}
              onChange={handleChange}
              placeholder="Author Name"
            />
          </div>
          <div className="form-group mb-3">
            <input
              type="text"
              className="form-control"
              name="slug"
              value={blog.slug}
              onChange={handleChange}
              placeholder="Slug"
            />
          </div>
          <div className="form-group mb-3">
            <input
              type="file"
              className="form-control"
              name="photo"
              onChange={handleFileChange}
            />
          </div>
          {blog.photo && !(blog.photo instanceof File) && (
            <div className="mb-3">
              <img
                src={blog.photo}
                alt="Blog Preview"
                style={{
                  width: "100%",
                  maxHeight: "200px",
                  objectFit: "cover",
                }}
              />
            </div>
          )}
          <button
            type="submit"
            className="btn btn-pink w-100"
            style={{
              backgroundColor: "#e83e8c",
              border: "none",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            }}
          >
            {loading ? "Updating..." : "Update Blog"}
          </button>
        </form>
      </div>
    </LayOut>
  );
};

export default UpdateBlog;
